const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000',
    FRONTEND_URL: window.location.origin || 'http://localhost:3000',
    // TASK-158: client ID de OAuth (Google Cloud) para "Continuar con Google". Vacío = botón oculto
    GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
    RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LclmHUsAAAAABsZm7DdtaDWw4Hxt5VukQbFHUh1',
    PUBLIC_VAPID_KEY: 'BAe5DsM7T_QMPdHre1mdPP1xDOPiU7K3CHvOCeUdpCPKfzbEmzCURA5tGVH0aOpfGTBBAPmhmRhjIlbGjL6PXkg'
};

export default config;
